/**
* DevExpress Analytics (core\selection\_selectionHelpers.js)
* Version:  20.2.9
* Build date: Aug 16, 2021
* Copyright (c) 2012 - 2021 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function deleteSelection(selection) {
    var focused = selection.focused();
    selection.selectedItems.forEach(function (item) {
        var itemModel = item.getControlModel(), parent = itemModel.parentModel();
        if (!item.getControlModel().getMetaData().isDeleteDeny && parent && item !== focused) {
            parent.removeChild(itemModel);
        }
    });
    focused.getControlModel().parentModel().removeChild(focused.getControlModel());
    selection.focused(findNextSelection(focused));
}
exports.deleteSelection = deleteSelection;
function findNextSelection(removedElement) {
    var parentSurface = removedElement.parent;
    var targetSurface = parentSurface;
    if (parentSurface) {
        var childrenCollection = parentSurface.getChildrenCollection()();
        var indexInCollection = childrenCollection.indexOf(removedElement);
        if (indexInCollection === -1 && childrenCollection.length > 0) {
            targetSurface = childrenCollection[childrenCollection.length - 1];
        }
        else if (childrenCollection.length > 1 && indexInCollection === childrenCollection.length - 1) {
            targetSurface = childrenCollection[indexInCollection - 1];
        }
        else if (childrenCollection.length > 1 && indexInCollection === 0) {
            targetSurface = childrenCollection[childrenCollection.length - 1];
        }
        else if (childrenCollection.length > 1) {
            targetSurface = childrenCollection[childrenCollection.length - 1];
        }
        else if (indexInCollection === -1 && targetSurface.parent && targetSurface.parent.getChildrenCollection()().indexOf(targetSurface) === -1) {
            targetSurface = findNextSelection(targetSurface);
        }
    }
    return targetSurface;
}
exports.findNextSelection = findNextSelection;
